var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',{attrs:{"name":"ArticleSlug","label":"Slug","value":_vm.slug,"maxlength":"250","counter":""},on:{"input":function($event){return _vm.changed($event)},"keydown":function($event){return _vm.$emit('keydown', $event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }